<template>
  <div class="modal modal-project-planner fade fixed-end" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">
            Project Details
          </h2>
          <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
        </div>
        <!-- /.drawer-heading -->

        <div class="modal-body">
          <div class="mb-3">
            <label class="control-label">Project</label>
            <input
              :disabled="isProject"
              name="title"
              v-model="stateName"
              type="text"
              class="form-control"
              placeholder=""
              v-validate="'required'"
            />

            <help-block field="title" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3">
            <label class="control-label">Project Stage</label>
            <multiselect
              :disabled="isProject"
              :show-labels="false"
              v-model="selectedStage"
              :options="stages"
              label="text"
              track-by="id"
              placeholder="Select Stage"
              data-vv-name="stage"
            ></multiselect>

            <help-block field="stage_id" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3">
            <label class="control-label">Client</label>
            <multiselect
              :disabled="isProject"
              :show-labels="false"
              v-model="selectedClient"
              :options="clients"
              label="display_name"
              track-by="id"
              placeholder="Select Client"
              data-vv-name="client"
            ></multiselect>

            <help-block field="stage_id" />
          </div>

          <div v-if="!isProject" class="mb-3">
            <label class="control-label">T&amp;M Project</label>
            <multiselect
              :show-labels="false"
              v-model="selectedBudget"
              :options="budgets"
              :allow-empty="true"
              label="name"
              track-by="id"
              placeholder="Select Budget"
              data-vv-name="stage"
              :disabled="ganttItem.budget_approval_id ? true : false"
            ></multiselect>

            <help-block field="budget_id" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3" v-if="stateBudgetId && !isProject">
            <label class="control-label">Number of hours</label>
            <div class="input-group">
              <input v-model="stateApprovedHours" type="number" class="form-control" placeholder="1" />
              <span class="input-group-addon">Hours</span>
            </div>
            <!-- /.input-group -->
          </div>
          <!-- /.form-group -->

          <div v-if="!isProject" class="mb-3">
            <div class="form-check">
              <input v-model="stateConfirmed" id="checkbox-project-confirmed" class="form-check-input" type="checkbox" />
              <label for="checkbox-project-confirmed" class="form-check-label">Project confirmed</label>
            </div>
          </div>
          <!-- /.form-group-material -->

          <h3 class="m-t-lg">Time Allocation</h3>

          <div class="row mb-3">
            <div class="col-6">
              <label class="control-label">Start Date</label>
              <datepicker
                name="start_date"
                v-model="stateStartDate"
                v-validate="'required'"
                data-vv-as="start date"
                input-class="form-control"
              ></datepicker>

              <help-block field="start_date" />
            </div>
            <div class="col-6">
              <label class="control-label">End Date</label>
              <datepicker
                name="end_date"
                v-model="stateEndDate"
                input-class="form-control"
                v-validate="'required'"
                data-vv-as="end date"
              ></datepicker>

              <help-block field="start_date" />
            </div>
          </div>
          <!-- /.form-group -->

          <div class="modal-footer">
            <div v-if="this.ganttItem.id && !isProject" class="m-b-sm float-start">
              <c-button type="danger" @click="handleDelete" class="btn btn-xs btn-danger">
                Remove Project
              </c-button>
            </div>

            <button type="button" class="btn btn-default" data-bs-dismiss="modal">
              Cancel
            </button>
            <c-button @click="handleSave" class="btn btn-rounded btn-primary">Save</c-button>
          </div>
        </div>
        <!-- /.drawer-body -->
      </div>
      <!-- /.drawer-contents -->
    </div>
  </div>
  <!-- /.drawer -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import { ganttStateMapper } from 'mixins/project-planner'
import { Selectize, LaddaButton } from 'components/form/input'
import moment from 'moment'
import { notify } from 'utils'
import { CModal } from '@chameleon/chameleon-vue'

export default {
  $_veeValidate: {
    validator: 'new', // give me my own validator scope.
  },

  extends: CModal,

  mixins: [ganttStateMapper],

  components: {
    Datepicker,
    LaddaButton,
    Selectize,
  },

  data() {
    return {
      stages: [
        { id: 1, text: 'Stage 1' },
        { id: 2, text: 'Stage 2' },
        { id: 3, text: 'Stage 3' },
      ],
    }
  },

  computed: {
    ...mapState('projectsPlanner', ['ganttItem']),
    ...mapState('budget', { budgets: 'list' }),
    ...mapState("clientsList", ["clients"]),

    isProject () {
      return this.ganttItem.project_stage != null
    },

    selectedStage: {
      get() {
        return this.stages.find(item => item.id === this.stateStageId)
      },

      set(value) {
        this.stateStageId = value.id
      },
    },

    selectedClient: {
      get() {
        return this.clients.find(item => item.id === this.stateClientId)
      },

      set(value) {
        this.stateClientId = value.id
      },
    },

    selectedBudget: {
      get() {
        return this.budgets.find(item => item.id === this.stateBudgetId)
      },

      set(value) {
        this.stateBudgetId = value ? value.id : null
      },
    },
  },

  mounted() {
    this.getBudgets()
    this.getClients()
  },

  methods: {
    ...mapActions('projectsPlanner', ['addGanttItem', 'updateProjectGanttItem', 'updateGanttItem', 'deleteGanttItem']),
    ...mapActions('budget', { getBudgets: 'getList' }),
    ...mapActions("clientsList", ["getClients"]),

    async handleSave() {
      //validate form
      if (!(await this._validate())) {
        notify.error('Form validation failed, please check your inputs and try again.')
        return Promise.reject()
      }

      if (this.ganttItem.id) {
        return this.handleUpdateItem()
      } else {
        return this.handleCreateItem()
      }
    },

    handleCreateItem() {
      let payload = {
        name: this.ganttItem.name,
        start_date: moment(this.ganttItem.start_date).format('YYYY-MM-DD'),
        end_date: moment(this.ganttItem.end_date).format('YYYY-MM-DD'),
        order: this.ganttItem.order,
        progress: this.ganttItem.progress,
        color: this.ganttItem.color,
        stage_id: parseInt(this.ganttItem.stage_id),
        client_id: parseInt(this.ganttItem.client_id),
        confirmed: this.ganttItem.confirmed,
      }

      return this.addGanttItem(payload)
        .then(response => {
          this.$emit('select-task', response.data.id)
          this.close()
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            notify.error('Form validation failed, please check your inputs and try again.')
          } else {
            notify.error('Sorry something went wrong making your request, please try again.')
          }
        })
    },

    handleUpdateItem() {
      if (this.isProject) {
        let payload = {
          commenced: moment(this.ganttItem.start_date).format("YYYY-MM-DD"),
          completed: moment(this.ganttItem.end_date).format("YYYY-MM-DD"),
        }

        return this.updateProjectGanttItem({ id: this.ganttItem.id, payload: payload })
          .then(() => {
            this.close()
          })
          .catch(error => {
            if (error.response && error.response.status === 422) {
              notify.error('Form validation failed, please check your inputs and try again.')
            } else {
              notify.error('Sorry something went wrong making your request, please try again.')
            }
          })
      } else {
        let payload = {
          name: this.ganttItem.name,
          start_date: moment(this.ganttItem.start_date).format('YYYY-MM-DD'),
          end_date: moment(this.ganttItem.end_date).format('YYYY-MM-DD'),
          order: this.ganttItem.order,
          progress: this.ganttItem.progress,
          color: this.ganttItem.color,
          stage_id: parseInt(this.ganttItem.stage_id),
          client_id: parseInt(this.ganttItem.client_id),
          confirmed: this.ganttItem.confirmed,
          budget_id: this.ganttItem.budget_id,
          approved_hours: this.ganttItem.approved_hours,
        }

        return this.updateGanttItem({ id: this.ganttItem.id.replace('G', ''), payload: payload })
          .then(() => {
            this.close()
          })
          .catch(error => {
            if (error.response && error.response.status === 422) {
              notify.error('Form validation failed, please check your inputs and try again.')
            } else {
              notify.error('Sorry something went wrong making your request, please try again.')
            }
          })
      }
    },

    handleDelete() {
      return this.deleteGanttItem(this.ganttItem.id.replace('G', '')).then(() => {
        this.close()
      })
    },
  },
}
</script>

<style>
</style>
